import { AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, ElementRef, HostListener, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';

import { AufnahmePunktDocument, istPunktartMitProtokoll, istPunktartMitKurzprotokoll, LastModified, Punktart, dateString, punktartSvgUrl, istPunktartOhneSymbol, punktartOhneSymbolLabel, punktartOhneSymbolColor } from '../../data-model';
import { DataService } from 'src/app/data.service';
import { LayerService, TransformationService, MapStatus, MapStatusService, StorageService, ConfirmService, WorkflowService, WorkflowTransitionModalComponent, pointStatusBadge, statusBadge, transitionButtonClass, transitionButtonLabel, PointStatus, hasUnresolvedDangerComments, ValidationLevel, RecentValuesService } from '@luzula/luzula-lib';
import { Command, NavbarService } from 'src/app/navbar.service';
import { AuthService } from 'src/app/auth.service';
import { ValidationService } from '../validation.service';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { updateAccordingly } from './bohrpunkt-detail.resolver';
import { FilterService } from 'src/app/filter.service';
import { ProjectService } from 'src/app/project.service';
import { ToastrService } from 'ngx-toastr';
import { PointFreigabeService } from './point-freigabe.service';
import { merkeGewaehltePunktart } from './punktart-favoriten';
import { verfahrenVon } from '../verfahren/verfahren';
import { UNBEKANNT_REITER, reiterFuerVerfahren, reiterGehoertNichtHierher } from '../verfahren/reiter-wahl';
import { KA_MASKEN } from '../verfahren/ka/ka-maske';
import { AbschnittId, uebernimmAbschnitte } from '../uebernahme/punkt-abschnitte';
import { Quellpunkt, quellpunkteFuer } from '../uebernahme/quellpunkte';
import { PunktdatenHolenComponent, PunktdatenHolenErgebnis } from '../uebernahme/punktdaten-holen.component';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-tabs',
    templateUrl: './bohrpunkt-tabs.component.html',
    styleUrls: ['./bohrpunkt-tabs.component.css'],
    
})
export class BohrpunktTabsComponent implements OnInit, OnDestroy, AfterViewInit {
	bp!: AufnahmePunktDocument;
	/** Punktart beim Oeffnen — nur eine Aenderung daran zaehlt als Wahl. */
	private punktartBeimLaden = '';
	bps: AufnahmePunktDocument[] = [];
	pointsFilter: boolean[] = [];
	
	displayMap = false;
	displayPlausi = false;
	mapStatus!: MapStatus;
	activeId = 'Allgemein';
	/**
	 * Ein Reiter je Block des amtlichen KA-Bogens. Beschriftung und Kennung sind der
	 * Titel der Maske dahinter, damit Reiter und Fenster gleich heissen.
	 *
	 * Lese-Zugriff und kein Feld: Ein Feld entsteht erst im Konstruktor, und die Tests
	 * dieses Ordners bauen das Bauteil ohne Konstruktor (`Object.create`, weil daran
	 * rund zwanzig Dienste haengen).
	 */
	get kaReiter() {
		return KA_MASKEN;
	}

	/** Der einzelne Reiter fuer ein Verfahren, das diese Fassung nicht kennt. */
	get unbekanntReiter(): string {
		return UNBEKANNT_REITER;
	}
	dirty = false;
	private dirtySubscription?: Subscription;
	private authChangedSubscription?: Subscription;
	private filtersSubscription?: Subscription;
	private filtersUpdatedSubscription?: Subscription;
	private hasSubscription?: Subscription;
	private routeSubscription?: Subscription;

	@ViewChild('nav', { static: true }) nav!: NgbNav;
	@ViewChild('controlToolbar') controlToolbar?: ElementRef<HTMLDivElement>;
	tabIds: string[] = [];

	istPunktartMitProtokoll = istPunktartMitProtokoll;
	istPunktartMitKurzprotokoll = istPunktartMitKurzprotokoll;
	dateString = dateString;
	punktartSvgUrl = punktartSvgUrl;
	istPunktartOhneSymbol = istPunktartOhneSymbol;
	punktartOhneSymbolLabel = punktartOhneSymbolLabel;
	punktartOhneSymbolColor = punktartOhneSymbolColor;

	C = Command;

	// Toolbar-Position (verschiebbar)
	toolbarPosition = { x: -1, y: 8 }; // -1 = noch nicht initialisiert
	private isDragging = false;
	private dragOffset = { x: 0, y: 0 };

	private cd = inject(ChangeDetectorRef);
	aus = inject(AuthService);
	private fs = inject(FilterService);
	ps = inject(ProjectService);
	ts = inject(TransformationService);
	private ds = inject(DataService);
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private storage = inject(StorageService);
	private recentValues = inject(RecentValuesService);
	ls = inject(LayerService);
	private mapStatusService = inject(MapStatusService);
	ns = inject(NavbarService);
	vs = inject(ValidationService);
	private confirmService = inject(ConfirmService);
	private workflow = inject(WorkflowService);
	private modalService = inject(NgbModal);
	private toastr = inject(ToastrService);
	private freigabe = inject(PointFreigabeService);

	// UI-Helper für Template — als Felder, damit *.html sie direkt ansprechen kann.
	statusBadge = statusBadge;
	transitionButtonClass = transitionButtonClass;
	transitionButtonLabel = transitionButtonLabel;

	constructor() {
		const appRef = inject(ApplicationRef);
		this.dirtySubscription = this.vs.dirty.subscribe((d: boolean) => {
			this.dirty = d;
			this.initButtons();
			// NavbarService.active_ wurde geändert — die Navbar ist ein Sibling-Component
			// und wird ohne expliziten CD-Tick nicht aktualisiert (z.B. Karte-Tab → Übernehmen)
			queueMicrotask(() => appRef.tick());
		});
		this.authChangedSubscription = this.aus.authChanged.subscribe(() => this.initButtons());
		this.hasSubscription = this.vs.has.subscribe((has: boolean) => {
			this.displayPlausi = has;
		});

		this.filtersSubscription = this.fs.apply.subscribe(() => this.onApplyFilter());
		this.filtersUpdatedSubscription = this.fs.filtersUpdated.subscribe(() => this.onApplyFilter());

		this.initButtons();
	}
	
	private initButtons() {
		this.ns.subscribe(Command.print, () => this.onPrint());
		this.ns.subscribe(Command.goBack, () => this.onDiscard());
		// „Aus anderem Punkt übernehmen" im Hauptmenü, über „Punkt löschen".
		if (this.kannDatenHolen) this.ns.subscribe(Command.punktdatenHolen, () => this.onDatenHolen());
		else this.ns.unsubscribe(Command.punktdatenHolen);
		// savePoint nur kontrollieren wenn keine HL-Area aktiv ist
		// (HL-Area ist aktiv wenn goBackToPoint aktiv ist)
		if (!this.ns.isActive(Command.goBackToPoint)) {
			const canWrite = this.ps.canIWritePoint(this.bp) && this.isAssignedToActiveProject();
			if (canWrite) {
				if (this.dirty) this.ns.subscribe(Command.savePoint, () => this.onSave());
				else this.ns.unsubscribe(Command.savePoint);
			}
			else {
				this.ns.unsubscribe(Command.savePoint);
			}
		}
	}

	/**
	 * Prüft ob der Punkt dem aktiven Projekt zugewiesen ist.
	 * Ohne geöffnetes Projekt ist keine Bearbeitung möglich.
	 */
	isAssignedToActiveProject(): boolean {
		// Single-Source in ProjectService (zuvor 3× inline reimplementiert).
		return this.ps.isPointAssignedToActiveProject(this.bp);
	}

	/**
	 * Zeigt Warnung wenn Punkt nicht dem aktiven Projekt zugewiesen ist.
	 */
	get showNotAssignedWarning(): boolean {
		const projectId = this.ps.project();
		if (!projectId) return false; // Kein Projekt aktiv → keine Warnung
		return !this.isAssignedToActiveProject();
	}

	ngAfterViewInit(): void {
		this.displayPlausi = this.vs.hasAny();
		this.cd.detectChanges(); // Ensure the view is updated after the async data is loaded
		this.tabIds = this.nav.items.map(item => item.id);
	}
	
	ngOnInit() {
		// Toolbar-Position wiederherstellen
		this.restoreToolbarPosition();

		this.routeSubscription = this.route.parent?.data.subscribe(data => {
			this.bp = data['bp'];
			this.punktartBeimLaden = this.bp.type;
			// Per-Punkt-Modus wird im Parent (BohrpunktComponent) initialisiert,
			// damit er beim Wechsel Tabs <-> HL-Area erhalten bleibt.
			// bps werden lazy geladen um die Navigation nicht zu blockieren
			this.initPoints();
			this.initButtons();
			this.mapStatus = {
				center: this.ts.from(this.bp.header.koordinaten),
				zoom: 17,
				bounds: this.mapStatusService.mapLimits.maxSubBounds
			}
			this.storage.get('BohrpunktActiveTab').then((value: any) => {
				// Konvertiere immer - auch wenn kein gespeicherter Tab vorhanden ist
				// (z.B. Allgemein -> Kurzprotokoll bei Kurzprotokoll-Punkten)
				const newActiveTab = this.reiterFuerPunkt(value || this.activeId, this.bp.type);
				this.activeId = newActiveTab;
				if (this.activeId === 'Karte')
					this.onDisplayMap();
			});
		});
	}

	private async initPoints() {
		const response = await this.ds.queryIndex();
		if (!response?.rows) {
			this.bps = [];
			return;
		}
		this.bps = response.rows.map((row: any) => {
			const mesoklima = row.key[7];
			const stfgData = row.key[8];
			const workflow = row.key[9] ?? undefined;
			return this.ds.updateBohrpunkt({
				_id: row.id,
				type: row.key[1],
				header: row.key[4],
				state: row.key[5],
				version: row.key[6],
				extendedHeader: (mesoklima || stfgData) ? { mesoklima: mesoklima || undefined, stfg: stfgData ? { naehrkraftStufe: stfgData.nk, stammFeuchteStufe: { first: stfgData.sf1, second: stfgData.sf } } : undefined } : undefined,
				workflow
			}, false); // Kein WMS-Fetch für Listen-Punkte
		});
		// Sichtbarkeitsfilter laut Workflow-Rolle: zentral via FilterService.
		this.bps = this.fs.applyWorkflowVisibility(this.bps);
		this.onApplyFilter();
	}
	
	ngOnDestroy(): void {
		this.ns.unsubscribe(Command.print);
		this.ns.unsubscribe(Command.savePoint);
		this.ns.unsubscribe(Command.discardPoint);
		this.ns.unsubscribe(Command.goBack);
		// Beim Öffnen einer Maske verschwindet diese Ansicht; dort gibt es den Eintrag nicht.
		this.ns.unsubscribe(Command.punktdatenHolen);
		this.dirtySubscription?.unsubscribe();
		this.authChangedSubscription?.unsubscribe();
		this.filtersSubscription?.unsubscribe();
		this.filtersUpdatedSubscription?.unsubscribe();
		this.hasSubscription?.unsubscribe();
		this.routeSubscription?.unsubscribe();
		// Per-Punkt-Modus + commenting/pen werden im Parent (BohrpunktComponent)
		// aufgeraeumt, der erst zerstoert wird, wenn der Bohrpunkt komplett
		// verlassen wird (nicht beim Wechsel in eine HL-Area).
	}

	onApplyFilter() {
			this.pointsFilter = this.bps.map(b => this.fs.filteredDocIds.has(b._id));
	}
	
	onDisplayMap() {
		this.displayMap = true;
	}

	onSave() {
		if (!this.dirty) return;
		this.ds.saveDocument(this.bp, { user: this.aus.currentUser });
		// Eine hier gewaehlte Punktart zaehlt erst jetzt — beim Speichern.
		merkeGewaehltePunktart(this.recentValues, this.storage, this.bp.type, this.punktartBeimLaden);
		this.punktartBeimLaden = this.bp.type;
		this.bps = updateAccordingly(this.bp, this.bps);
		this.dirty = false;
		this.vs.dirty.next(false);
	}

	async onDiscard() {
		if (!this.dirty) {
			this.router.navigate(['/']);
			return;
		}
		const result = await this.confirmService.confirm({
			title: 'Ungespeicherte Änderungen',
			message: 'Es gibt ungespeicherte Änderungen an diesem Punkt.',
			confirmText: 'Verwerfen',
			confirmClass: 'btn-warning',
			extraText: 'Speichern & zurück',
			extraClass: 'btn-success',
			cancelText: 'Bleiben'
		});
		if (result === 'extra') {
			await this.onSave();
			this.router.navigate(['/']);
		} else if (result === true) {
			// Dokument aus DB neu laden, um In-Memory-Änderungen zurückzusetzen
			try {
				const freshBp = await firstValueFrom(this.ds.getDocument$(this.bp._id));
				Object.assign(this.bp, this.ds.updateBohrpunkt(freshBp as any, false));
			} catch (e) { /* Fallback: trotzdem navigieren */ }
			this.dirty = false;
			this.vs.dirty.next(false);
			this.router.navigate(['/']);
		}
	}
	
	/**
	 * Welcher Reiter soll bei DIESEM Punkt offen sein?
	 *
	 * Der zuletzt geoeffnete Reiter wird ueber ALLE Punkte hinweg gemerkt
	 * (`BohrpunktActiveTab` im Geraetespeicher). Beim Wechsel auf einen Punkt mit
	 * anderer Punktart oder anderem Verfahren muss er umgerechnet werden - sonst
	 * zeigt `activeId` auf einen Reiter, den es hier nicht gibt, und dann ist GAR
	 * KEINER offen (eine leere Flaeche, ohne Hinweis, warum).
	 *
	 * Steht als eigene Methode und nicht als Hilfsfunktion in `ngOnInit`, damit sich
	 * genau dieser Weg pruefen laesst (`bohrpunkt-tabs-reiterwahl.spec.ts`).
	 */
	reiterFuerPunkt(gemerkt: string, type: Punktart): string {
		// Kein SEA-Punkt: Die SEA-Reiter gibt es dort nicht (siehe reiter-wahl.ts).
		const verfahren = verfahrenVon(this.bp);
		const fremd = reiterFuerVerfahren(gemerkt, verfahren);
		if (fremd) return fremd;
		// Umgekehrt: Ein Reiter eines anderen Verfahrens gilt hier als „nichts
		// gemerkt", damit unten der Standard des Punktes greift.
		const id = reiterGehoertNichtHierher(gemerkt, verfahren) ? '' : gemerkt;
		// Punktarten mit Protokoll: Kurzprotokoll -> Allgemein
		if (id === 'Kurzprotokoll' && istPunktartMitProtokoll(type)) return 'Allgemein';
		// Punktarten ohne Protokoll aber mit Kurzprotokoll: Allgemein -> Kurzprotokoll
		if (id === 'Allgemein' && istPunktartMitKurzprotokoll(type)) return 'Kurzprotokoll';
		// Boden/Vegetation nur bei Protokoll-Punkten
		if ((id === 'Boden' || id === 'Vegetation') && istPunktartMitKurzprotokoll(type)) return 'Kurzprotokoll';
		// Fallback: Standard-Tab für den Punkttyp
		if (!id || id === '') {
			return istPunktartMitProtokoll(type) ? 'Allgemein' : 'Kurzprotokoll';
		}
		return id;
	}

	/** Ist das ein Punkt nach SEA 95? Alle Punkte ohne Vermerk sind es. */
	istSeaPunkt(): boolean {
		return verfahrenVon(this.bp) === 'sea95';
	}

	/**
	 * Ein Verfahren, das diese Fassung der App nicht kennt. Dann gibt es einen
	 * einzigen Reiter mit einem Hinweis statt der Reiter des Bogens.
	 */
	verfahrenUnbekannt(): boolean {
		return verfahrenVon(this.bp) === 'unbekannt';
	}

	onPrint() {
		// Das Druckblatt ist das SEA-Protokoll. Fuer eine Aufnahme nach KA kaeme ein
		// leeres SEA-Blatt heraus: lieber sagen, dass es den Druck noch nicht gibt.
		if (!this.istSeaPunkt()) {
			this.toastr.info('Den Druck für Aufnahmen nach KA gibt es noch nicht.');
			return;
		}
		this.router.navigate([`/bohrpunkte/Drucken/${this.bp._id}`]);
	}
	
	onNavChange(data: any) {
		this.storage.setSync('BohrpunktActiveTab', data.nextId);
	}

	onPointDeleted() {
		this.router.navigate(['/']);
	}

	formatLastModified(lm: LastModified): string {
		const date = new Date(lm.time);
		const dateStr = date.toLocaleDateString('de-DE');
		const timeStr = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
		return `Zuletzt geändert: ${dateStr} ${timeStr} von ${lm.user}`;
	}

	// === Workflow-Status ===

	get currentStatus(): PointStatus | null {
		return this.bp?.workflow?.status ?? null;
	}

	get currentBadge() {
		// pointStatusBadge mit Workflow-Block (statt nur Status): erkennt auch
		// V11→V12-Migrations-Bestand (status='abgeschlossen' + createdBy.id='system'
		// + History [from=null,to='abgeschlossen']) als „Bestand".
		return pointStatusBadge(this.bp?.workflow);
	}

	get availableTransitions(): PointStatus[] {
		if (!this.bp) return [];
		return this.workflow.availableTransitions(this.bp);
	}

	/**
	 * Altpunkt-Übernahme (Einfachmodell, PLAN-single-membership): Manager (+
	 * Entwickler-Bypass) übernimmt einen Altpunkt (Status `null`/Bestand oder
	 * `abgeschlossen`) ins aktive Projekt — Workflow-Reset + **Umhängen**
	 * (`PointFreigabeService`). Anders als früher ist KEINE Vorab-Zuordnung mehr
	 * nötig: der Button greift direkt auf jedem Altpunkt (auch fremden), denn die
	 * generische „Zuordnen"-Funktion entfällt. Owner ohne Manager-Rolle hat seit
	 * 2026-05-26 keine Freigabe-Capability (siehe `canIfreigeben`).
	 *
	 * Dieser Toolbar-Button erscheint nur, wenn der Punkt für mich editierbar ist
	 * (Entwickler, nicht eingefroren). Frozen Fremd-Altpunkte und Manager (read-
	 * only) übernehmen über den Banner-Button (bohrpunkt.component,
	 * `canFreigebenInBanner`) — keine Dopplung.
	 */
	get canFreigeben(): boolean {
		if (!this.bp) return false;
		// `canIfreigebenPoint` kombiniert Rolle + aktives Projekt + Altpunkt-Status
		// + Nicht-bereits-zugeordnet (User-Befund 2026-06-02: Button war auch bei
		// schon zugeordneten Punkten sichtbar → No-Op-Übernahme).
		if (!this.ps.canIfreigebenPoint(this.bp)) return false;
		if (this.workflow.isFrozen(this.bp)) return false;
		return this.ps.canIWritePoint(this.bp);
	}

	// === Daten aus einem anderen Punkt übernehmen (PLAN-punktdaten-uebernehmen.md) ===

	/**
	 * Nur in einem SEA-Protokoll und nur, wo auch gespeichert werden darf: dieselbe
	 * Bedingung wie der Speichern-Knopf dieser Ansicht (`initButtons`). Eine Übernahme
	 * ist eine Bearbeitung und darf kein zweiter Weg an den Rechten vorbei sein.
	 */
	get kannDatenHolen(): boolean {
		if (!this.bp) return false;
		if (!this.istSeaPunkt() || !istPunktartMitProtokoll(this.bp.type)) return false;
		return this.ps.canIWritePoint(this.bp) && this.isAssignedToActiveProject();
	}

	/** Die Punkte, aus denen sich Daten holen lassen: aktives Projekt, die nächsten zuerst. */
	quellpunkte(): Quellpunkt[] {
		const hier = this.ts.from(this.bp.header.koordinaten);
		return quellpunkteFuer(
			this.bps,
			this.bp,
			p => this.ps.isPointAssignedToActiveProject(p),
			p => {
				try {
					const dort = this.ts.from(p.header?.koordinaten);
					return hier && dort ? hier.distanceTo(dort) : undefined;
				} catch {
					return undefined;
				}
			},
		);
	}

	async onDatenHolen(): Promise<void> {
		if (!this.kannDatenHolen) return;
		const ref = this.modalService.open(PunktdatenHolenComponent, { size: 'lg' });
		ref.componentInstance.ziel = this.bp;
		ref.componentInstance.kandidaten = this.quellpunkte();
		let ergebnis: PunktdatenHolenErgebnis | undefined;
		try {
			ergebnis = await ref.result;
		} catch {
			return; // abgebrochen
		}
		if (ergebnis) this.uebernimmAusPunkt(ergebnis.quelle, ergebnis.abschnitte);
	}

	/**
	 * Übernimmt die Abschnitte in den offenen Punkt und setzt „geändert". Gespeichert
	 * wird NICHT: Man sieht das Ergebnis und speichert oder verwirft wie bei jeder
	 * Bearbeitung („Verwerfen" lädt den Punkt aus der Datenbank neu).
	 */
	uebernimmAusPunkt(quelle: any, abschnitte: AbschnittId[]): void {
		if (!this.kannDatenHolen || !quelle || !abschnitte?.length) return;
		uebernimmAbschnitte(this.bp, quelle, abschnitte);
		this.dirty = true;
		this.vs.dirty.next(true);
		const nummer = String(quelle?.header?.nummer ?? '').trim();
		const woher = nummer ? `aus Punkt ${nummer}` : 'aus dem gewählten Punkt';
		this.toastr.info(`Übernommen ${woher}. Bitte prüfen und speichern.`);
		this.cd.markForCheck();
	}

	async onFreigeben(): Promise<void> {
		if (this.dirty) {
			this.toastr.warning('Bitte erst die offenen Änderungen speichern oder verwerfen.');
			return;
		}
		const result = await this.freigabe.freigeben(this.bp);
		if (result.ok && result.doc) {
			Object.assign(this.bp, result.doc);
			this.bps = updateAccordingly(this.bp, this.bps);
			this.notifyPointChanged();
			this.cd.markForCheck();
		}
	}

	/**
	 * Kontrolleur-Reopen (Lebenszyklus 2026-05-27): eingetragener Projekt-
	 * Kontrolleur (Urlaubsvertretung) bzw. Entwickler holt einen abgeschlossenen
	 * Punkt zurück „in die Kontrolle" (→ in_pruefung). Nur solange das Projekt
	 * NICHT explizit abgeschlossen ist — Gate in ProjectService.canIReopenPoint.
	 */
	get canReopen(): boolean {
		if (!this.bp) return false;
		return this.ps.canIReopenPoint(this.bp);
	}

	async onReopen(): Promise<void> {
		if (this.dirty) {
			this.toastr.warning('Bitte erst die offenen Änderungen speichern oder verwerfen.');
			return;
		}
		const result = await this.workflow.reopenPointToReview(this.bp);
		if (result.ok && result.doc) {
			Object.assign(this.bp, result.doc);
			this.bps = updateAccordingly(this.bp, this.bps);
			this.cd.markForCheck();
		} else if (result.reason) {
			this.toastr.error(result.reason);
		}
	}

	async onTransition(target: PointStatus): Promise<void> {
		// Vor dem Modal: ungespeicherte Änderungen verhindern silent dataloss.
		if (this.dirty) {
			this.toastr.warning('Bitte erst die offenen Änderungen speichern oder verwerfen.');
			return;
		}

		const ref = this.modalService.open(WorkflowTransitionModalComponent, { size: 'lg', scrollable: true });
		ref.componentInstance.doc = this.bp;
		ref.componentInstance.targetStatus = target;
		ref.componentInstance.fromStatus = this.currentStatus;

		try {
			const result = await ref.result as { message?: string; forceUnresolved?: boolean };
			// Wenn der User im Modal "Trotzdem abschließen" gewählt hat (forceUnresolved),
			// werden offene Kommentare explizit ignoriert; bei "Alle auflösen und
			// abschließen" hat das Modal sie bereits resolved gesetzt, sodass
			// bp.state.resolved ohnehin nicht mehr false ist.
			const hasUnresolved = result?.forceUnresolved
				? false
				: this.bp.state?.resolved === false;
			const result_ = await this.workflow.transition(this.bp, target, {
				input: this.buildInput(target, result?.message),
				context: {
					hasBlockingDataIssues: this.bp.state?.dataSeverity === ValidationLevel.danger,
					hasUnresolvedComments: hasUnresolved,
					hasDangerComments: hasUnresolvedDangerComments(this.bp)
				}
			});
			if (!result_.ok) {
				this.toastr.error(result_.reason ?? 'Status-Wechsel fehlgeschlagen');
				return;
			}
			if (result_.doc) {
				Object.assign(this.bp, result_.doc);
				this.bps = updateAccordingly(this.bp, this.bps);
				this.cd.markForCheck();
			}
			this.toastr.success(`Neuer Status: ${this.currentBadge?.label ?? target}`);
		} catch (_dismissed) {
			// Modal-Abbruch — ohne Toast.
		}
	}

	/**
	 * Nach einer erfolgreichen Übernahme (Workflow-Reset ins aktive Projekt) den
	 * geänderten Punkt über `pointSaved` melden.
	 *
	 * Der Reset wird vom Workflow-System der Lib direkt geschrieben (`data.put`),
	 * NICHT über `DataService.saveDocument` — d.h. ohne dieses explizite Signal
	 * bekommen Cache-Hörer den Wechsel nicht mit. Konkret cacht `HlAreaDirective`
	 * ([bpHl]) ihre „darf ich editieren?"-Entscheidung und verwirft den Cache nur
	 * auf `pointSaved`; sonst bleiben die anklickbaren Protokoll-Bereiche nach der
	 * Übernahme gesperrt, bis der Punkt verlassen + neu geöffnet wird. Reiner
	 * Refresh — die Rechte-Regeln bleiben unberührt. (Die Status-Buttons selbst
	 * leben im Hinweise-Tab → siehe BohrpunktPlausiComponent.)
	 */
	private notifyPointChanged() {
		this.ds.pointSaved.emit(this.bp);
	}

	private buildInput(target: PointStatus, message?: string) {
		if (target === 'abgelehnt') return { rejectionMessage: message };
		if (target === 'abgeschlossen') return { approvalMessage: message };
		return {};
	}

	// === Toolbar Drag & Drop ===

	onToolbarDragStart(event: MouseEvent | TouchEvent): void {
		event.preventDefault();
		this.isDragging = true;

		const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
		const clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;

		// Initialisiere Position beim ersten Drag
		if (this.toolbarPosition.x < 0 && this.controlToolbar) {
			const rect = this.controlToolbar.nativeElement.getBoundingClientRect();
			const parentRect = this.controlToolbar.nativeElement.parentElement?.getBoundingClientRect();
			if (parentRect) {
				this.toolbarPosition.x = rect.left - parentRect.left;
				this.toolbarPosition.y = rect.top - parentRect.top;
			}
		}

		this.dragOffset = {
			x: clientX - this.toolbarPosition.x,
			y: clientY - this.toolbarPosition.y
		};
	}

	@HostListener('document:mousemove', ['$event'])
	@HostListener('document:touchmove', ['$event'])
	onToolbarDragMove(event: MouseEvent | TouchEvent): void {
		if (!this.isDragging) return;

		const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
		const clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;

		this.toolbarPosition = {
			x: clientX - this.dragOffset.x,
			y: clientY - this.dragOffset.y
		};
	}

	@HostListener('document:mouseup')
	@HostListener('document:touchend')
	onToolbarDragEnd(): void {
		if (this.isDragging) {
			this.isDragging = false;
			// Position speichern
			this.storage.setSync('controlToolbarPosition', JSON.stringify(this.toolbarPosition));
		}
	}

	private restoreToolbarPosition(): void {
		const saved = this.storage.getSync('controlToolbarPosition');
		if (saved) {
			try {
				const pos = JSON.parse(saved);
				if (pos.x >= 0 && pos.y >= 0) {
					this.toolbarPosition = pos;
				}
			} catch (e) {
				// Ignorieren
			}
		}
	}
}
